// extracted by mini-css-extract-plugin
module.exports = {"modal":"InputResultModal_modal__1L2Tz"};